const locale = {
  HEADER_ARIA_LABEL: 'Encabezado de navegación principal',
  NAV_ARIA_LABEL: 'Navegación principal',
  MENU_BUTTON_ARIA_LABEL: 'Abrir menú de navegación',
  NOTIFICATIONS_ARIA_LABEL: 'Notificaciones',
  ACCOUNT_MENU_ARIA_LABEL: 'Menú de cuenta',
  IKIGAI_BUTTON_LABEL: 'Descubre tu carrera ideal',
};

export default locale;
